import { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../lib/firebase.js';
import AuthHeader from './AuthHeader.jsx';
import SEO from '../components/SEO.jsx';
import PublicFonts from '../components/PublicFonts.jsx';
import './landing.css';

// We use Firebase Auth's built-in password reset email for v0 — it's the fastest
// path and the email looks fine. We'll customise the template later.

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await sendPasswordResetEmail(auth, email.trim().toLowerCase());
      setDone(true);
    } catch (err) {
      // Don't leak whether the email exists.
      if (err.code === 'auth/invalid-email') {
        setError('Please enter a valid email.');
      } else {
        setDone(true);
      }
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <div className="lp3 lp3-auth auth-shell">
        <SEO title="Reset password" noIndex />
        <PublicFonts />
        <div className="auth-card">
          <AuthHeader />
          <h1>Check your email</h1>
          <p className="subtitle">
            If an account exists for that email, we've sent a password reset link.
            Look for an email from Giraops.
          </p>
          <div className="footer">
            <Link to="/login" className="auth-link">Back to sign in</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="lp3 lp3-auth auth-shell">
      <SEO title="Reset password" noIndex />
      <PublicFonts />
      <form className="auth-card" onSubmit={onSubmit}>
        <AuthHeader />
        <h1>Reset password</h1>
        <p className="subtitle">Enter your email and we'll send you a reset link.</p>

        <label htmlFor="email">Email <span className="req">*</span></label>
        <input
          id="email" type="email" autoComplete="email" required
          value={email} onChange={(e) => setEmail(e.target.value)}
        />

        <button type="submit" disabled={busy}>{busy ? 'Sending…' : 'Send reset link'}</button>
        {error && <div className="error">{error}</div>}

        <div className="footer">
          <Link to="/login" className="auth-link">Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}
